import { render, staticRenderFns } from "./Qualities.vue?vue&type=template&id=22a93ff5"
import script from "./Qualities.vue?vue&type=script&lang=js"
export * from "./Qualities.vue?vue&type=script&lang=js"
import style0 from "./Qualities.vue?vue&type=style&index=0&id=22a93ff5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports